import { render, staticRenderFns } from "./FormatsIndex.vue?vue&type=template&id=60696d72"
import script from "./FormatsIndex.vue?vue&type=script&lang=js"
export * from "./FormatsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports